if (!customElements.get("facet-filters")) {
  class FacetFilters extends SideDrawer {
    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener("popstate", this.historyChangeHandler);
      this.breakpointChangeHandler &&
        window.removeEventListener("on:breakpoint-change", this.breakpointChangeHandler);
    }

    init() {
      this.filteringEnabled = this.dataset.filtering === "true";
      this.sortingEnabled = this.dataset.sorting === "true";
      this.form = document.getElementById("facets");
      this.results = document.getElementById("filter-results");

      if (this.filteringEnabled) {
        this.filters = this.querySelector(".facets__filters");
        this.activeFilters = this.querySelector(".facets__active-filters");
        this.activeFiltersList = this.querySelector(".active-filters");
        this.activeFiltersHeader = this.querySelector(".active-filters-header");
        this.footer = this.querySelector(".facets__footer");
      }

      if (this.sortingEnabled) {
        this.mobileSortByOptions = this.querySelectorAll(".js-drawer-sort-by");
        this.desktopSortBy = document.querySelector(".products-toolbar__sort");
      }

      this.handleBreakpointChange();
      this.addListeners();
    }

    addListeners() {
      if (this.filteringEnabled) {
        this.breakpointChangeHandler =
          this.breakpointChangeHandler || this.handleBreakpointChange.bind(this);

        this.filters.addEventListener("click", this.handleFiltersClick.bind(this));
        this.filters.addEventListener(
          "input",
          debounce(this.handleFilterChange.bind(this), 500)
        );
        this.activeFilters.addEventListener(
          "click",
          this.handleActiveFiltersClick.bind(this)
        );

        window.addEventListener("on:breakpoint-change", this.breakpointChangeHandler);
      }

      if (this.sortingEnabled) {
        this.desktopSortBy.addEventListener("change", this.handleFilterChange.bind(this));
      }

      this.historyChangeHandler =
        this.historyChangeHandler || this.handleHistoryChange.bind(this);
      window.addEventListener("popstate", this.historyChangeHandler);
    }

    handleBreakpointChange() {
      if (theme.mediaMatches.lg) {
        this.setAttribute("open", "");
        this.setAttribute("aria-hidden", "false");
        this.removeAttribute("aria-modal");
        this.removeAttribute("role");
      } else {
        this.close();
        this.setAttribute("role", "dialog");
        this.setAttribute("aria-modal", "true");
        this.setAttribute("aria-hidden", "true");
        this.hidden = !1;
      }
    }

    handleFilterChange(evt) {
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData);
      const emptyParams = [];

      if (this.sortingEnabled) {
        let currentSortBy = searchParams.get("sort_by");
        if (evt.target.tagName === "CUSTOM-SELECT") {
          this.mobileSortByOptions.forEach((option) => {
            option.checked = option.value === evt.detail.selectedValue;
            currentSortBy = evt.detail.selectedValue;
          });
        }

        if (currentSortBy && currentSortBy !== "null") {
          searchParams.set("sort_by", currentSortBy);
        } else {
          searchParams.delete("sort_by");
        }
      }

      searchParams.forEach((value, key) => {
        if (!value) emptyParams.push(key);
      });
      emptyParams.forEach((key) => {
        searchParams.delete(key);
      });

      // Debug
      console.log("🟢 Params generados:", searchParams.toString());

      this.applyFilters(searchParams.toString(), evt);
    }

    handleFiltersClick(evt) {
      const { target } = evt;
      if (target.matches(".js-clear-filter")) {
        evt.preventDefault();
        this.applyFilters(new URL(evt.target.href).searchParams.toString(), evt);
      }

      if (target.matches(".js-show-more")) {
        const filter = target.closest(".filter");
        target.remove();
        filter.querySelectorAll("li").forEach((el) => {
          el.classList.remove("js-hidden");
        });
      }
    }

    handleActiveFiltersClick(evt) {
      if (evt.target.tagName === "A") {
        evt.preventDefault();
        this.applyFilters(new URL(evt.target.href).searchParams.toString(), evt);
      }
    }

    handleHistoryChange(evt) {
      if (evt.state !== null) {
        let searchParams = "";
        evt.state && evt.state.searchParams && ({ searchParams } = evt.state);
        this.applyFilters(searchParams, null, !1);
      }
    }

    async applyFilters(searchParams, evt, updateUrl = !0) {
      const customPagination = document.querySelector("custom-pagination");
      if (customPagination) {
        customPagination.dataset.pauseInfiniteScroll = "true";
      }

      this.results.classList.add("is-loading");

      const closeBtn = this.querySelector(".js-close-drawer-mob");
      if (closeBtn) {
        closeBtn.ariaDisabled = "true";
        closeBtn.classList.add("is-loading");
      }

      // Debug
      console.log("🌍 Fetch a:", `${window.location.pathname}?${searchParams}`);

      const response = await fetch(`${window.location.pathname}?${searchParams}`);
      if (response.ok) {
        const tmpl = document.createElement("template");
        tmpl.innerHTML = await response.text();

        if (this.filteringEnabled) {
          this.updateFilters(tmpl.content, evt);
        }

        if (closeBtn) {
          closeBtn.innerText = tmpl.content.querySelector(".js-close-drawer-mob").innerText;
        }

        this.results.innerHTML = tmpl.content.getElementById("filter-results").innerHTML;

        typeof initLazyImages == "function" && initLazyImages();
        window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets();
        customPagination && customPagination.reload && customPagination.reload();
        updateUrl && FacetFilters.updateURL(searchParams);

        if (this.results.getBoundingClientRect().top < 0) {
          let headerHeight = 0;
          document.querySelector('store-header[data-is-sticky="true"]') &&
            (headerHeight =
              Number.parseInt(
                getComputedStyle(this.parentElement)
                  .getPropertyValue("--header-height")
                  .replace("px", ""),
                10
              ) || 0);
          window.scrollTo({
            top:
              this.results.getBoundingClientRect().top +
              window.scrollY -
              headerHeight -
              45,
            behavior: "smooth",
          });
        }

        if (closeBtn) {
          closeBtn.classList.remove("is-loading");
          closeBtn.removeAttribute("aria-disabled");
        }
        if (customPagination) {
          customPagination.dataset.pauseInfiniteScroll = "false";
        }
        document.dispatchEvent(new CustomEvent("on:facet-filters:updated", { bubbles: !0 }));
      }
      this.results.classList.remove("is-loading");
    }

    updateFilters(html, evt) {
      document.querySelectorAll(".filter").forEach((filter) => {
        const { index } = filter.dataset;
        const fetchedFilter = html.querySelector(`.filter[data-index="${index}"]`);

        if (filter.dataset.type !== "sort") {
          if (filter.dataset.type === "price_range") {
            FacetFilters.updateFilter(filter, fetchedFilter, !1);
            (!evt || evt.target.tagName !== "INPUT") &&
              filter.querySelectorAll("input").forEach((input) => {
                input.value = html.getElementById(input.id).value;
              });
          } else if (evt && evt.target.tagName === "INPUT") {
            const changedFilter = evt.target.closest(".filter");
            changedFilter &&
              changedFilter.dataset &&
              FacetFilters.updateFilter(
                filter,
                fetchedFilter,
                filter.dataset.index !== changedFilter.dataset.index
              );
          } else {
            FacetFilters.updateFilter(filter, fetchedFilter, !0);
          }
        }
      });

      this.updateActiveFilters(html);
      const footerEl = html.querySelector(".facets__footer");
      this.footer.innerHTML = footerEl.innerHTML;
    }

    static updateFilter(filter, fetchedFilter, updateAll) {
      if (fetchedFilter) {
        filter.hidden = !1;
        if (updateAll) {
          filter.innerHTML = fetchedFilter.innerHTML;
        } else {
          filter.replaceChild(
            fetchedFilter.querySelector(".filter__toggle"),
            filter.querySelector(".filter__toggle")
          );
          filter.querySelector(".filter__header").innerHTML =
            fetchedFilter.querySelector(".filter__header").innerHTML;
        }
      } else {
        filter.hidden = !0;
      }
    }

    updateActiveFilters(html) {
      const activeFiltersList = html.querySelector(".active-filters");
      const activeFiltersHeader = html.querySelector(".active-filters-header");
      this.activeFiltersList.innerHTML = activeFiltersList.innerHTML;
      this.activeFiltersHeader.innerHTML = activeFiltersHeader.innerHTML;
      this.activeFilters.hidden = !this.activeFiltersList.querySelector(".active-filter");
    }

    static updateURL(searchParams) {
      window.history.pushState(
        { searchParams },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
      );
    }
  }

  customElements.define("facet-filters", FacetFilters);
}
